import { createRequest, platform, Data, AdditionalParams } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { Trip, TripSortKeys } from "./types"
import { fromApi } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

type SearchTripsInputBase = Readonly<{
  policyId: string
  startedAtAfter?: string
  startedAtBefore?: string
}>
export type SearchTripsInput = SearchTripsInputBase & AdditionalParams<TripSortKeys>
type SearchTripsOutput = Data<Trip>

const searchTrips = createRequest<SearchTripsInput, SearchTripsOutput>(
  async (input: SearchTripsInput, getToken): Promise<SearchTripsOutput> => {
    const api = platform(getToken)
    const useNewPipeline = isNewPipelinePolicy(input.policyId)
    const result = await api.trips.searchTrips({
      ...input,
      ...(useNewPipeline ? { dbName: `athena` } : {}),
    })

    return {
      ...result,
      items: result.items.map((it) => fromApi(it)),
    }
  }
)

export const useSearchTrips = createRequestHook<SearchTripsInput, SearchTripsOutput, TripSortKeys>(searchTrips)
